import React, { Component } from "react";
import { connect } from "react-redux";
import { func, bool, arrayOf, shape } from "prop-types";
import * as Yup from "yup";
import { selectors as investmentfundsSelectors, actions as investmentfundsActions } from "reducers/investmentfunds";
import { selectors as sessionSelectors } from "reducers/session";
import * as i18n from "util/i18n";
import Col from "react-bootstrap/lib/Col";
import { Field, Form, Formik } from "formik";
import PageLoading from "pages/_components/PageLoading";
import MainContainer from "pages/_components/MainContainer";
import { ResponsiveHeader } from "pages/_components/header";
import Container from "pages/_components/Container";
import Notification from "pages/_components/Notification";
import CustomText from "pages/_components/CustomText/CustomText";
import Checkbox from "pages/_components/Checkbox";
import Button from "pages/_components/Button";
import I18n from "pages/_components/I18n";
import Title from "pages/_components/fields/Title";

const FORM_ID = "investmentFunds.investorTest";
class InvestorTest extends Component {
    static propTypes = {
        dispatch: func.isRequired,
        fetching: bool.isRequired,
        fetchingSubmit: bool.isRequired,
        questions: arrayOf(shape({})).isRequired,
        activeEnvironment: shape({}).isRequired,
        history: shape({ goBack: func }),
    };

    static defaultProps = {
        history: null,
    };

    constructor(props) {
        super(props);
        this.formRef = React.createRef();
    }

    componentDidMount() {
        const { dispatch } = this.props;
        dispatch(investmentfundsActions.investorTestPre());
    }

    handleCheckboxChange = (fieldName, idQuestion) => {
        const { questions } = this.props;
        const { current } = this.formRef;
        for (const question of questions) {
            if (idQuestion === question.idQuestion) {
                for (const answer of question.answers) {
                    current.setFieldValue(
                        `question_${question.idQuestion}answer_${answer.idAnswer}`,
                        fieldName === `question_${question.idQuestion}answer_${answer.idAnswer}`,
                    );
                    current.setFieldValue(`question_${idQuestion}`, true);
                    current.setTouched(`question_${idQuestion}`, true);
                }
            }
        }
    };

    handleSubmit = (values) => {
        const { activeEnvironment, questions, dispatch } = this.props;
        let score = 0;
        const userAnswers = [];
        for (const question of questions) {
            for (const answer of question.answers) {
                const fieldValue = values[`question_${question.idQuestion}answer_${answer.idAnswer}`];
                if (fieldValue) {
                    score += answer.score;
                    const userAnswer = questions[question.idQuestion - 1];
                    const result = userAnswer.answers.map((userAnswer) => ({
                        ...userAnswer,
                        checked:
                            question.idQuestion === userAnswer.idQuestion && answer.idAnswer === userAnswer.idAnswer,
                    }));
                    userAnswer.answers = result;
                    userAnswers.push(userAnswer);
                }
            }
        }
        const params = { score, userCuil: activeEnvironment?.activeUserCuil, userAnswers };
        dispatch(investmentfundsActions.investorTestSend(params));
    };

    validationSchema = () => {
        const { questions } = this.props;
        const validateObj = {};
        for (const question of questions) {
            Object.assign(validateObj, {
                [`question_${question.idQuestion}`]: Yup.bool().required("Campo obligatorio"),
            });
        }
        return Yup.object().shape(validateObj);
    };

    render() {
        const { questions, fetching, fetchingSubmit, history } = this.props;
        return (
            <PageLoading loading={fetching}>
                <Notification scopeToShow="investmentfunds" />
                <ResponsiveHeader
                    id="investmentFunds.investorTest.send"
                    className="header-without-button"
                    onBack={history.goBack}
                />
                <MainContainer className="main-container">
                    <h3>
                        <CustomText text="investmentFunds.investorTest.subtitle" textType="I18N" />
                    </h3>
                    <p>{i18n.get("investmentFunds.investorTest.questions.text")}</p>
                    <Formik onSubmit={this.handleSubmit} validationSchema={this.validationSchema} ref={this.formRef}>
                        {({ values }) => {
                            const answeredCount = questions.filter((q) => values[`question_${q.idQuestion}`]).length;
                            const disabled = answeredCount !== questions.length;
                            return (
                                <Form className="above-the-fold">
                                    <Container className="items-center container--layout">
                                        {questions.map((question) => (
                                            <React.Fragment key={question.idQuestion}>
                                                <Field
                                                    idForm={FORM_ID}
                                                    name={`question_${question.idQuestion}`}
                                                    component={Title}
                                                    text={question.question}
                                                    bold
                                                />
                                                {question.answers.map((answer) => (
                                                    <Field
                                                        key={answer.idAnswer}
                                                        component={Checkbox}
                                                        idForm={FORM_ID}
                                                        name={`question_${question.idQuestion}answer_${answer.idAnswer}`}
                                                        onChange={() =>
                                                            this.handleCheckboxChange(
                                                                `question_${question.idQuestion}answer_${answer.idAnswer}`,
                                                                question.idQuestion,
                                                            )
                                                        }
                                                        labelClassName="concepts-checkbox"
                                                        labelFromService
                                                        labelText={answer.answer}
                                                    />
                                                ))}
                                                <div className="pb-6" />
                                            </React.Fragment>
                                        ))}
                                        <div className="pb-6" />
                                        {/* Declaración jurada justificada */}
                                        <div className="justify-content-center row">
                                            <div style={{ textAlign: "justify" }}>
                                                <I18n id="investmentFunds.investorTest.sworn.declaration" />
                                            </div>
                                        </div>
                                        <div className="pb-6" />
                                        <Col xs={12} md={8} mdOffset={2} lg={6} lgOffset={3}>
                                            <Button
                                                type="submit"
                                                bsStyle="primary"
                                                label="global.send"
                                                loading={fetchingSubmit}
                                                disabled={disabled}
                                            />
                                        </Col>
                                    </Container>
                                </Form>
                            );
                        }}
                    </Formik>
                </MainContainer>
            </PageLoading>
        );
    }
}
const mapStateToProps = (state) => ({
    fetching: investmentfundsSelectors.getFetching(state),
    fetchingSubmit: investmentfundsSelectors.getFetchingSubmit(state),
    questions: investmentfundsSelectors.getQuestions(state),
    activeEnvironment: sessionSelectors.getActiveEnvironment(state),
});
export default connect(mapStateToProps)(InvestorTest);
